<template>
<div>
    <section id="home">
        <div>
            <v-row class="text-center">
                <v-col cols="12">
                    <v-img :src="require('../assets/logo.svg')" class="my-3" style="
                animation: fadeIn ease-in-out 1.5s, moveDown ease-in-out 1.5s;
              " contain height="200" />
                </v-col>
                <v-col>
                    <h3 class="motto" style="
                animation: fadeIn ease-in-out 1.5s, moveUp ease-in-out 1.5s;
              ">
                        Partner dla twojej produkcji
                    </h3>
                </v-col>
            </v-row>
            <v-row class="text-center pa-4">
                <v-col v-for="(service, i) in services" :key="service.id">
                    <v-btn :x-large="!isMobile" x-medium :style="
                'opacity:0;animation: fadeIn ease-in-out 1s;animation-delay:' +
                (0.7 + i / 3) +
                's;animation-fill-mode: forwards;  '
              " @click="goTo(service.id)" color="primary" dark>
                        <v-icon class="pr-2 costum-icon">{{ service.icon }}</v-icon>
                        {{ service.header }}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </section>
    <bp_offer v-for="service in services" :id="service.id" :haveSketch="service.haveSketch" :key="service.id">
        <template slot="icon">{{ service.icon }}</template>
        <template slot="header">{{ service.header }}</template>
        <template slot="description">
            <span v-html="service.description"></span>
        </template>
        <template slot="sketch" v-if="service.haveSketch">
            <robot />
        </template>
        <template slot="images" v-if="service.images">
            <v-col aligin="center" v-for="(image, i) in service.images" :key="i">
                <v-img class="photo" :src="image.url" :alt="image.description" height="300" aspect-ratio="1" contain @click="showPhoto(image.url, image.description)"></v-img>
                <div class="mt-3 text-center">{{ image.description }}</div>
            </v-col>
        </template>
    </bp_offer>

    <bp_offer :id="companyInfo.id">
        <template slot="icon">{{ companyInfo.icon }}</template>
        <template slot="header">{{ companyInfo.header }}</template>
        <template slot="description">
            <span v-html="companyInfo.description"></span>
        </template>
    </bp_offer>

    <bp_offer :id="realizations.id">
        <template slot="icon">{{ realizations.icon }}</template>
        <template slot="header">{{ realizations.header }}</template>
        <template slot="description">
            <span v-html="realizations.description"></span>
        </template>
        <template slot="images" v-if="realizations.images">
            <v-col v-for="(image, i) in realizations.images" :key="i">
                <v-img @click="showPhoto(image.url, image.description)" class="white--text align-end photo" bottom :src="image.url" :alt="image.description" aspect-ratio="2">
                </v-img>
                <div class="mt-3">{{ image.description }}</div>
            </v-col>
        </template>
    </bp_offer>
    <photoViewer :photoViewer="photoViewer"></photoViewer>
    <video width="100%" height="350" autoplay loop muted>
        <source :src="require('@/assets/videos/work.mp4')" type="video/mp4" />
        Twoja przeglądarka nie obsługuje Video.
    </video>
</div>
</template>

<script>
// @ is an alias to /src
import bp_offer from "@/components/bp_offer.vue";
import photoViewer from "@/components/photoViewer.vue";
import robot from "@/components/robot.vue";
export default {
    name: "Home",
    components: {
        bp_offer,
        photoViewer,
        robot,
    },

    data() {
        return {
            test: false,
            photoViewer: {
                show: false,
                url: String,
                title: String,
            },
            services: [{
                    id: "prefabrykacja",
                    icon: `$prefabrication`,
                    header: `Prefabrykacja`,
                    description: `<p>Kompleksowe wykonanie:</p>
          <ul>
            <li>rozdzielnic elektrycznych niskiego napięcia na podstawie dostarczonej dokumentacji.</li>
            <li>rozdzielnic mieszkaniowych</li>
            <li>szaf sterowniczych przemysłowych</li>
          </ul>
          <br/>
          <p> Wszystkie szafy zostają wykonane zgodnie z normą PN-EN 61439, wystawiamy deklarację UE. Nasze produkty zostają testowane przed opuszczeniem montowni, charakteryzują się starannością wykonania a zastosowane materiały są najwyższej jakości.</p>
          `,
                    images: [{
                        url: require("@/assets/images/Rozdzielnia zasilająca blok mieszkalny.jpg"),
                        description: "Rozdzielnia zasilająca blok mieszkalny",
                    }, ],
                },
                {
                    id: "modernizacja",
                    icon: `$modernization_machinery_control`,
                    header: `Modernizacja`,
                    description: `<p>Wykonujemy modernizację sterowania starych maszyn przemysłowych, gdzie stan mechaniczny pozwala na wieloletnią pracę.Sterowanie oparte o producenta wskazanego przez klienta lub zaproponowane przez naszych inżynierów.</p>
          <p>Maszyna po wymianie sterowania może otrzymać znak CE.</p>
          <p>W zakres oferty wchodzi również wykonanie projektu sterowania, modernizacja elementów mechanicznych, ocena ryzyka i wykonanie dokumentacji DTR.</p>`,
                },
                {
                    id: "automatyzacja",
                    icon: `$automatic_production`,
                    haveSketch: true,
                    header: `Automatyzacja`,
                    description: `<p>Wykonujemy stanowiska produkcyjne i maszyny dostosowane do potrzeb klienta:</p>
          <ul>
            <li>stanowiska montażowe</li>
            <li>stanowiska zrobotyzowane</li>
            <li>doposażenie istniejących linii, maszyn w nowe funkcje usprawniające produkcje</li>
            <li>rozwiązania problemów produkcyjnych</li>
          </ul>`,
                },
                {
                    id: "ce",
                    icon: `$ce`,
                    header: `CE`,
                    description: `<p>Dokonujemy audytów bezpieczeństwa maszyn, dokonujemy dostosowania do obowiązujących norm bezpieczeństwa  i wystawiamy certyfikat CE. Procedura może być wykonana dla starych maszyn jak również dla nowo projektowanych.</p>`,
                },
                {
                    id: "wspolpraca",
                    icon: `$cooperation`,
                    header: `Współpraca z konstruktorami`,
                    description: `<p>Współpracujemy z działami konstruktorskimi klienta, na podstawie spotkań jesteśmy w stanie wypracować plan działania i wspólnie z klientem zaprojektować i zbudować urządzenie usprawniające produkcję</p>`,
                },
            ],
            companyInfo: {
                id: "informacje",
                icon: `$info`,
                header: `Informacje`,
                description: `<p></p>Od lat domeną naszej firmy jest prefabrykacja szaf sterowniczych, kompleksowa realizacja systemów automatyzacji produkcji, a także indywidualne zamówienia związane z modernizacją maszyn i urządzeń produkcyjnych. W prowadzonych realizacjach duży nacisk kładziemy na jakość, funkcjonalność i estetykę wykonania. Z chęcią podejmujemy się realizacji wymagających projektów indywidualnych jak i seryjnym produkcjom.</p>`,
            },
            realizations: {
                id: "realizacje",
                icon: `$realizations`,
                header: `Realizacje`,
                description: `<p>Zdjęcia wybranych realizcji:</p>`,
                images: [{
                        url: require("@/assets/images/Zasilanie placu miejskiego1.jpg"),
                        description: "Zasilanie placu miejskiego",
                    },
                    {
                        url: require("@/assets/images/Sterowanie małym robotem.jpg"),
                        description: "Sterowanie małym robotem",
                    },
                    {
                        url: require("@/assets/images/Zasialnie główne osiedla.jpg"),
                        description: "Zasialnie główne osiedla",
                    },
                ],
            },
        };
    },
    methods: {
        goTo(target) {
            this.$vuetify.goTo(`#${target}`, {
                offset: 100,
            });
        },
        showPhoto(url, title) {
            this.photoViewer = {
                show: true,
                url: url,
                title: title,
            };
        },
    },
    mounted() {},
    metaInfo() {
        return {
            title: "JKP Elektromontaż Kamil Szydlik - Warszawa, Mazowieckie",
            meta: [{
                    name: "description",
                    content: "JKP Elektromontaż zajmuje się prefabrykacją szaf sterowniczych i rozdzielni budynkowych, modernizacją sterowania maszyn przemysłowych, automatyzacją produkcji, projektowaniem automatyki przemysłowej, gotowe rozdzielnie.",
                },
                {
                    property: "og:title",
                    content: "JKP Elektromontaż - automatycacja produkcji.",
                },
                {
                    property: "og:site_name",
                    content: "JKP Elektromontaż",
                },
                {
                    property: "og:type",
                    content: "website",
                },
                {
                    name: "robots",
                    content: "index,follow",
                },
            ],
        };
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
    },
};
</script>

<style lang="scss">
video {
    object-fit: cover;
}

#home {
    height: 100vh;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .motto {
        color: #000000;
        text-transform: uppercase;
        letter-spacing: 10px;
    }
}

.fade-in {
    animation: (fadeIn ease-in-out 1.5s, moveDown ease-in-out 1.5s);
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes moveDown {
    0% {
        transform: translate(0px, -50px);
    }

    100% {
        transform: translate(0px, 0px);
    }
}

@keyframes moveUp {
    0% {
        transform: translate(0px, 50px);
    }

    100% {
        transform: translate(0px, 0px);
    }
}

.photo {
    cursor: pointer;
}
</style>
